/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Create_Note_Hint_SuffixInputs */

const en_read_along_create_note_hint_suffix = /** @type {(inputs: Read_Along_Create_Note_Hint_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`button`)
};

const es_read_along_create_note_hint_suffix = /** @type {(inputs: Read_Along_Create_Note_Hint_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

/**
* | output |
* | --- |
* | "button" |
*
* @param {Read_Along_Create_Note_Hint_SuffixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_create_note_hint_suffix = /** @type {((inputs?: Read_Along_Create_Note_Hint_SuffixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Create_Note_Hint_SuffixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_create_note_hint_suffix(inputs)
	return en_read_along_create_note_hint_suffix(inputs)
});